import { z } from "zod";

export const QUIZ_QUESTION_FORMATS = [
	"MULTIPLE_CHOICE_SINGLE",
	"MULTIPLE_CHOICE_MULTI",
	"FILL_IN_BLANK",
	"TYPE_ANSWER",
	"WORD_REORDER",
	"RANK_ORDER",
	"PAIR_MATCHING",
] as const;

export const quizQuestionFormatSchema = z.enum(QUIZ_QUESTION_FORMATS);

export type QuizQuestionFormat = z.infer<typeof quizQuestionFormatSchema>;

export const QUIZ_ANSWER_ROLES = [
	"CORRECT",
	"DISTRACTOR",
	"NONE_OF_THESE",
	"ALL_OF_THESE",
	"BLANK_FILL",
	"WORD_BANK_TOKEN",
	"REORDER_TOKEN",
	"RANK_ITEM",
	"PAIR_LEFT",
	"PAIR_RIGHT",
] as const;

export const quizAnswerRoleSchema = z.enum(QUIZ_ANSWER_ROLES);

export type QuizAnswerRole = z.infer<typeof quizAnswerRoleSchema>;
